'use client';

import {
  Avatar,
  Button,
  Center,
  CloseButton,
  Stack,
  Text,
  Title,
  em,
  rem,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import {
  closeAllModals,
  closeModal,
  type ContextModalProps,
} from '@mantine/modals';
import { useTranslations } from 'next-intl';
import { ModalName } from '.';
import { assetPrefix } from '@/lib/constants';

export type OnboardingPickupTimeModalProps = {
  onConfirm?: () => void;
};

const OnboardingPickupTimeModal = ({
  innerProps,
}: ContextModalProps<OnboardingPickupTimeModalProps>) => {
  const { onConfirm } = innerProps;
  const isMobile = useMediaQuery(`(max-width: ${em(767)})`);
  const tPickupTime = useTranslations('booking.pickup_time');
  const tCommon = useTranslations('common');

  const handleConfirmOnboarding = () => {
    if (!onConfirm) return;

    onConfirm();
    closeModal(ModalName.OnboardingPickupTime);
  };

  const handleClose = () => {
    closeAllModals();
  };
  return (
    <>
      <CloseButton
        pos="absolute"
        iconSize={rem(24)}
        variant="transparent"
        onClick={handleClose}
        c="neutral.6"
        top={rem(16)}
        style={
          isMobile
            ? {
                left: rem(16),
                outline: 'none',
              }
            : {
                right: rem(16),
                outline: 'none',
              }
        }
      />
      <Center mb={rem(24)}>
        <Avatar
          radius="md"
          variant="outline"
          w={rem(240)}
          h={rem(200)}
          flex="none"
          src={`${assetPrefix}/static/images/pickup-time-onboarding.webp`}
          alt={'pickup-time-onboarding'}
          styles={{
            placeholder: {
              border: 'none',
            },
          }}
        ></Avatar>
      </Center>

      <Stack gap={rem(12)} mb={rem(8)}>
        <Title ta="center" order={3} c="neutral.7">
          {tPickupTime('title')}
        </Title>

        <Text size="sm" fw={500} ta="center" c="neutral.7">
          {tPickupTime('onboarding_description')}
        </Text>

        <Button
          fullWidth
          mih={rem(48)}
          fw={700}
          onClick={handleConfirmOnboarding}
          size="sm"
        >
          {tCommon('continues')}
        </Button>
      </Stack>
    </>
  );
};
//

export default OnboardingPickupTimeModal;
